<script setup lang="ts">
import { computed } from 'vue';
import { priceFormat } from '../helpers/priceFormat';
import { PortfolioAsset } from '@sonarwatch/portfolio-core';
import useCurrentCurrency from '@/helpers/currency/useCurrentCurrency';

const props = defineProps<{
  asset: PortfolioAsset;
}>();

const currentCurrency = useCurrentCurrency();

const computedPrice = computed(() => {
  return priceFormat(
    props.asset.data.price,
    currentCurrency.rate.value,
    currentCurrency.currency.value,
  );
});
</script>

<template>
  <span v-if="computedPrice">
    {{ computedPrice }}
  </span>
</template>
